import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=790c8ae1&"
import script from "./changePassword.vue?vue&type=script&lang=ts&"
export * from "./changePassword.vue?vue&type=script&lang=ts&"
import style0 from "./changePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports